module.exports = __webpack_public_path__ + "img/charisma.326835d5.svg";